var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 50,
    rx: 12,
    fill: "#FE9003"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.002 20C22.014 17.825 22.11 16.647 22.879 15.879C23.757 15 25.172 15 28 15H29C31.828 15 33.243 15 34.121 15.879C35 16.757 35 18.172 35 21V29C35 31.828 35 33.243 34.121 34.121C33.243 35 31.828 35 29 35H28C25.171 35 23.757 35 22.879 34.121C22.11 33.353 22.014 32.175 22.002 30",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22 32.5C19.643 32.5 18.464 32.5 17.732 31.768C17 31.035 17 29.857 17 27.5V22.5C17 20.143 17 18.964 17.732 18.232C18.464 17.5 19.643 17.5 22 17.5",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 25H20M20 25L22 27M20 25L22 23",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.48aef89492acdc140923470266d1269a.svg";
export { ForwardRef as ReactComponent };